import { useQuery } from "@apollo/client";
import { AppContext } from "AppContainer";
import Errors from "components/Errors";
import Spinner from "components/Spinner";
import { useContext } from "react";
import DraftView from "./DraftView";
import { GET_SUPPLIER_FOR_REGISTRATION } from "./graphql";
import RejectedView from "./RejectedView";
import VerifiedView from "./VerifiedView";

const RegisterPage = () => {
  const { user } = useContext(AppContext);
  const id = user.supplier.id;
  const { loading, error, data } = useQuery(GET_SUPPLIER_FOR_REGISTRATION, {
    variables: { id },
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  if (user.supplier.state === "REJECTED") return <RejectedView />;
  if (user.supplier.state === "COMPLETED_ONBOARDING") return <VerifiedView />;

  return (
    <DraftView
      originalSupplier={data.supplierForRegister}
      originDraftData={
        data.supplierForRegister.draftData
          ? JSON.parse(data.supplierForRegister.draftData)
          : {}
      }
    />
  );
};

export default RegisterPage;
